import React, { useEffect, useRef } from 'react';
// import { CloseIcon } from './UtilsLayout';

const ModalAdd = React.memo(
  ({ isOpen, closeModal, children, className, inset }) => {
    const modalRef = useRef(null);

    useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = 'hidden'; // Disable background scroll
      } else {
        document.body.style.overflow = 'auto'; // Enable background scroll
      }

      return () => {
        document.body.style.overflow = 'auto'; // Clean up on unmount
      };
    }, [isOpen]);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          closeModal();
        }
      };

      if (isOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      }

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen, closeModal]);

    if (!isOpen) return null;

    return (
      <div
        className={`fixed inset-0 ${
          inset === 'false' ? '' : 'bg-black bg-opacity-50'
        } flex items-start justify-end z-10`}
      >
        <div
          className={`bg-[#1A1B1E] rounded-md shadow-lg max-w-[220px] text-[10px] relative top-[100px] right-[10px]  overflow-auto ${className}`}
        >
          <div ref={modalRef} className="relative ">
            {children}
          </div>
        </div>
      </div>
    );
  }
);

export default ModalAdd;
